import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useCampaignContext } from "common/helpers/CampaignContext";

import { formattedTimezone } from "../../../utils";
import Schedule from "../../Schedule";
import SectionHeading from "../../SectionHeading";
import ScheduleEdit from "./ScheduleEdit";

export default function CampaignSchedule() {
  const { schedule: campaignSchedule } = useCampaignContext();
  const { timezone, ...initialSchedule } = campaignSchedule;
  const [schedule, setSchedule] = useState(initialSchedule);
  const [isEditingSchedule, setIsEditingSchedule] = useState(false);
  const [selectedTimezone, setSelectedTimezone] = useState(
    formattedTimezone(timezone),
  );

  const { t } = useTranslation("campaigns");

  function resetSchedule() {
    setIsEditingSchedule(false);
    setSchedule(initialSchedule);
  }

  return (
    <>
      <section className="flex justify-between gap-4">
        <SectionHeading
          title={t("scheduleTitle")}
          subtitle={t("scheduleTitle")}
        />
        <ScheduleEdit
          isEditing={isEditingSchedule}
          setIsEditing={setIsEditingSchedule}
          resetSchedule={resetSchedule}
          selectedTimezone={selectedTimezone}
          schedule={schedule}
        />
      </section>

      <Schedule
        schedule={schedule}
        timezone={selectedTimezone}
        setSchedule={setSchedule}
        setSelectedTimezone={setSelectedTimezone}
        isDisabled={!isEditingSchedule}
      />
    </>
  );
}
